import Box from "@mui/material/Box";
import Button from "@mui/material/Button";
import Typography from "@mui/material/Typography";
import React from "react";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";

import { useUser } from "../../hooks/useAuth";
import { usePartyGameByShellId } from "../../hooks/usePartyCatalog";
import { PartyTopBar } from "../../party/PartyChrome";
import { PartyMascot } from "../../party/PartyMascot";

export default function PartyPlayPlaceholder({ shellId }: { shellId: string }) {
  const navigate = useNavigate();
  const { t } = useTranslation();
  const { data: user } = useUser();
  const { data: g, isLoading } = usePartyGameByShellId(shellId);

  const goPurchase = () => {
    if (!user) {
      navigate(`/login?next=${encodeURIComponent("/purchase")}`);
      return;
    }
    navigate("/purchase");
  };

  if (isLoading && !g) {
    return (
      <Box sx={{ p: 6, textAlign: "center", color: "var(--ink-dim)" }}>…</Box>
    );
  }

  return (
    <Box sx={{ height: "100dvh", display: "flex", flexDirection: "column", p: 2.5 }}>
      <PartyTopBar title={(g?.nameEn ?? shellId).toUpperCase()} onBack={() => navigate(`/party/detail/${shellId}`)} />
      <Box
        sx={{
          flex: 1,
          display: "flex",
          flexDirection: "column",
          justifyContent: "center",
          alignItems: "center",
          textAlign: "center",
        }}
      >
        <PartyMascot shellId={shellId} size={140} />
        <Typography className="party-display" sx={{ fontSize: 48, lineHeight: 0.95, mt: 1.75 }}>
          {g?.nameAr ?? shellId}
        </Typography>
        <Typography sx={{ color: "var(--ink-dim)", mt: 1.25, fontSize: 15, maxWidth: 320, lineHeight: 1.5 }}>
          {t("party.playPlaceholder.body")}
        </Typography>
        <Box sx={{ display: "flex", flexDirection: "column", gap: 1.25, mt: 3, width: "100%", maxWidth: 360 }}>
          <Button type="button" onClick={goPurchase} className="party-btn party-btn-paper" fullWidth sx={{ py: 1.5 }}>
            {t("party.playPlaceholder.shopCta")}
          </Button>
          <Box sx={{ display: "flex", gap: 1.25 }}>
            <Button type="button" onClick={() => navigate("/party/play/imposter")} className="party-btn party-btn-hot" sx={{ flex: 1, py: 1.5 }}>
              {t("party.playPlaceholder.tryImposter")}
            </Button>
            <Button type="button" onClick={() => navigate("/party/play/guess")} className="party-btn party-btn-ghost" sx={{ flex: 1, py: 1.5 }}>
              {t("party.playPlaceholder.tryGuess")}
            </Button>
          </Box>
        </Box>
      </Box>
    </Box>
  );
}
